module.exports = __webpack_public_path__ + "static/media/kcmfb.2808d28c.png";